export default {
  SuperAdmin: 'SuperAdmin',
  StoreAdmin: 'StoreAdmin',
  StoreManagerAdmin: 'StoreManagerAdmin',
  StoreCustomerAdmin: 'StoreCustomerAdmin',
  AdministratorAdmin: 'AdministratorAdmin',
  ArticleAdmin: 'ArticleAdmin',
  VideoSubmissionAdmin: 'VideoSubmissionAdmin',
  VideoApprovalAdmin: 'VideoApprovalAdmin',
  SalesAdmin: 'SalesAdmin',
  GoLiveRewardAdmin: 'GoLiveRewardAdmin',
  VideoManager: 'VideoManager'
}
